import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ProjectNote,
  ProjectNotesListResponse,
} from '@stfors/shared-types';
import { api } from '../client';

export function useProjectNotes(projectId: number | null) {
  return useQuery({
    queryKey: ['project-notes', { project_id: projectId }],
    queryFn: ({ signal }) =>
      api.get<ProjectNotesListResponse>(
        `/api/project-notes?project_id=${projectId}`,
        signal,
      ),
    enabled: projectId !== null,
  });
}

export interface CreateProjectNoteInput {
  project_id: number;
  content: string;
  is_important?: boolean;
}

export function useCreateProjectNote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateProjectNoteInput) =>
      api.post<{ project_note: ProjectNote }>('/api/project-notes', input),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({
        queryKey: ['project-notes', { project_id: vars.project_id }],
      });
    },
  });
}

export function useDeleteProjectNote(projectId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (noteId: number) =>
      api.delete<void>(`/api/project-notes/${noteId}`),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: ['project-notes', { project_id: projectId }],
      });
    },
  });
}
